/// <reference types="../../types/react-i18next" />

import { Trans as TransComponent, TransProps } from 'react-i18next';

import { II18n, useTranslation } from '../util/useTranslation';

export const Trans = <Key extends string, Element>(
  props: Omit<TransProps<Key, string, undefined, Element>, 'i18n' | 'i18nKey'> & {
    i18nKey: string;
  }
) => {
  const { i18n } = useTranslation();
  return <TransComponent i18n={i18n as II18n} {...props} />;
};
